import { LazyLoadImage } from 'react-lazy-load-image-component';

import styled, { css } from 'styled-components';

export type StyledImageProps = {
  opacity?: string;
  asAutoSize?: boolean;
  isBudget?: boolean;
};

const Wrapper = styled.figure<StyledImageProps>`
  position: relative;

  margin: 0;

  ${({ asAutoSize }) =>
    !asAutoSize
      ? css`
          width: 100%;
          height: 100%;
        `
      : ''}

  .lazy-load-image-background {
    position: absolute;

    top: 50%;
    left: 50%;

    transform: translate(-50%, -50%);

    img {
      width: 15rem;
      height: 5rem;
    }
  }

  .error-image {
    position: absolute;
    top: ${({ isBudget }) => (isBudget ? '6rem' : '50%')};
    left: 50%;

    transform: translate(-50%, -50%);
    object-fit: scale-down;
    object-position: center;
    max-width: 15rem;
    height: auto;

    img {
      width: 15rem;
      height: 5rem;
    }
  }

  .lazy-load-image-background.lazy-load-image-loaded {
    position: static;
    height: 100%;

    ${({ asAutoSize }) =>
      !asAutoSize
        ? css`
            width: 100%;
          `
        : ''}

    transform: translate(0, 0);

    img {
      width: 100%;
      height: 100%;
    }
  }
`;

const Image = styled(LazyLoadImage)<StyledImageProps>`
  display: block;

  width: 100%;
  height: 100%;

  object-fit: cover;
  object-position: 50% 0;
  object-position: ${({ isBudget }) => (isBudget ? '0 0 ' : '50% 0')};

  border-style: none;

  opacity: ${({ opacity }) => opacity};
`;

export { Wrapper, Image };
